// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
Header nav
*/
.header-nav ul {
  list-style: none;
}

.header-nav > ul {
  margin: 0;
  padding: 0;
}

.header-nav .nav-icon {
  font-size: 22px;
  color: #012970;
  margin-right: 25px;
  position: relative;
}

.header-nav .nav-profile {
  color: #012970;
}

.header-nav .nav-profile img {
  max-height: 36px;
}
.header-nav .nav-profile span {
  font-size: 14px;
  font-weight: 600;
}

.header-nav .badge-number {
  position: absolute;
  inset: -2px -5px auto auto;
  font-weight: normal;
  font-size: 12px;
  padding: 3px 6px;
}

.header-nav .notifications {
  inset: 8px -15px auto auto !important;
}

.header-nav .notifications .notification-item {
  display: flex;
  align-items: center;
  padding: 15px 10px;
  transition: 0.3s;
}

.header-nav .notifications .notification-item i {
  margin: 0 20px 0 10px;
  font-size: 24px;
}

.header-nav .notifications .notification-item h4 {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 5px;
}

.header-nav .notifications .notification-item p {
  font-size: 13px;
  margin-bottom: 3px;
  color: #919191;
}

.header-nav .notifications .notification-item:hover {
  background-color: #f6f9ff;
}

.header-nav .profile {
  min-width: 240px;
  padding-bottom: 0;
  top: 8px !important;
}

.header-nav .profile .dropdown-header h6 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 0;
  color: #444444;
}

.header-nav .profile .dropdown-header span {
  font-size: 14px;
}

.header-nav .profile .dropdown-item {
  font-size: 14px;
  padding: 10px 15px;
  transition: 0.3s;
}

.header-nav .profile .dropdown-item i {
  margin-right: 10px;
  font-size: 18px;
  line-height: 0;
}

.header-nav .profile .dropdown-item:hover {
  background-color: #f6f9ff;
}
`, "",{"version":3,"sources":["webpack://./src/components/proto/components/Dashboard/nav.css"],"names":[],"mappings":"AAAA;;CAEC;AACD;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["/*\nHeader nav\n*/\n.header-nav ul {\n  list-style: none;\n}\n\n.header-nav > ul {\n  margin: 0;\n  padding: 0;\n}\n\n.header-nav .nav-icon {\n  font-size: 22px;\n  color: #012970;\n  margin-right: 25px;\n  position: relative;\n}\n\n.header-nav .nav-profile {\n  color: #012970;\n}\n\n.header-nav .nav-profile img {\n  max-height: 36px;\n}\n.header-nav .nav-profile span {\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.header-nav .badge-number {\n  position: absolute;\n  inset: -2px -5px auto auto;\n  font-weight: normal;\n  font-size: 12px;\n  padding: 3px 6px;\n}\n\n.header-nav .notifications {\n  inset: 8px -15px auto auto !important;\n}\n\n.header-nav .notifications .notification-item {\n  display: flex;\n  align-items: center;\n  padding: 15px 10px;\n  transition: 0.3s;\n}\n\n.header-nav .notifications .notification-item i {\n  margin: 0 20px 0 10px;\n  font-size: 24px;\n}\n\n.header-nav .notifications .notification-item h4 {\n  font-size: 16px;\n  font-weight: 600;\n  margin-bottom: 5px;\n}\n\n.header-nav .notifications .notification-item p {\n  font-size: 13px;\n  margin-bottom: 3px;\n  color: #919191;\n}\n\n.header-nav .notifications .notification-item:hover {\n  background-color: #f6f9ff;\n}\n\n.header-nav .profile {\n  min-width: 240px;\n  padding-bottom: 0;\n  top: 8px !important;\n}\n\n.header-nav .profile .dropdown-header h6 {\n  font-size: 18px;\n  font-weight: 600;\n  margin-bottom: 0;\n  color: #444444;\n}\n\n.header-nav .profile .dropdown-header span {\n  font-size: 14px;\n}\n\n.header-nav .profile .dropdown-item {\n  font-size: 14px;\n  padding: 10px 15px;\n  transition: 0.3s;\n}\n\n.header-nav .profile .dropdown-item i {\n  margin-right: 10px;\n  font-size: 18px;\n  line-height: 0;\n}\n\n.header-nav .profile .dropdown-item:hover {\n  background-color: #f6f9ff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
